import axios from "axios";

/** Preserve HTTP status on rethrown bootstrap/API errors (axios shape for guestv2). */
export function rethrowRequestError(errResponse: unknown): never {
  if (axios.isAxiosError(errResponse)) {
    const status = errResponse.response?.status;
    const errorCode = (errResponse.response?.data as { errorCode?: number })?.errorCode;
    const message =
      errResponse.message ||
      errResponse.code ||
      (status ? `HTTP ${status}` : "request failed");
    const detail =
      errorCode !== undefined ? `${message} (errorCode ${errorCode})` : message;
    const error = new Error(detail) as Error & {
      response?: typeof errResponse.response;
      status?: number;
    };
    error.response = errResponse.response;
    error.status = status;
    throw error;
  }

  if (errResponse instanceof Error) {
    throw errResponse;
  }

  throw new Error(String(errResponse));
}
